/* Hook encargado de hacer la consulta a la base y 
traer la reserva a partir de su id

Autor: Benjamín León
Fecha: 2024-08-16
*/
import { useState } from 'react'

import { formatDateToYYYY_MM_DD } from '../utils/utils.ts'
import Reservation from '../interfaces/Reservation.ts'
import { customFetch } from '../utils/customFetch.ts'

import { makeUrlReservation } from './connectionData.tsx'

const useReservationFetcher = () => {
  const [errorReservation, setErrorReservation] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchReservation = async (id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlReservation(id)
      const data = await customFetch<Reservation>(apiUrl)
      const notes = Array.isArray(data.notes) ? (data.notes ?? []).join('\n') : data.notes
      const payments = (data.payments ?? []).map((p) => {
        return { ...p, date: formatDateToYYYY_MM_DD(new Date(p.date)) }
      })
      const additionals = (data.additionals ?? []).map((p) => {
        return { ...p, date: formatDateToYYYY_MM_DD(new Date(p.date)) }
      })
      // Esto es para tener "inmutabilidada" en variables
      // Creamos variable nueva en vez de modificar "data"
      const datanew = {
        ...data,
        date: formatDateToYYYY_MM_DD(new Date(data.date)),
        payments: payments,
        additionals: additionals,
        notes: notes,
      }
      setErrorReservation(null)

      return datanew
    } catch (err) {
      // Assert the error as an instance of Error
      if (err instanceof Error) {
        setErrorReservation(err)
      } else {
        setErrorReservation(new Error('An unknown error occurred'))
      }

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorReservation, loading, fetchReservation }
}
export default useReservationFetcher
